export default __webpack_public_path__ + "static/media/clear.8ac5b59e.jpg";